<h1>Print Attributes</h1>

<div class="toolbar actions-bar" fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-md="column"
  fxLayoutAlign.lt-md="start start">
  <button
    *ngIf="canEdit()"
    appAuthorizeControl="edit||eventmang"
    type="button"
    mat-raised-button
    color="accent"
    matTooltip="Add new record"
    [routerLink]="[0]"
    data-testid="New Print Attribute"
  >
    <mat-icon class="">add</mat-icon>Add Print Attribute
  </button>

  <button type="button" mat-stroked-button
      *ngIf="canEdit() && getSelectedSectionRecords().length"
    [matMenuTriggerFor]="menu" matTooltip="Actions">
    <mat-icon>more_vert</mat-icon>Actions 
  </button>
  <mat-menu #menu="matMenu" class="mat-dropdown-menu">
    <button type="button" mat-menu-item
      (click)="cloneSelectedRecords()"><mat-icon>content_copy</mat-icon>Clone</button>
    <button type="button" mat-menu-item
      (click)="downloadCSV()"><mat-icon>file_download</mat-icon>Download CSV</button>
    <button type="button" mat-menu-item
      (click)="deleteSelectedRecords()"><mat-icon>delete</mat-icon>Delete</button>
    <button type="button" mat-menu-item
      *ngIf="(getSelectedSectionRecords().length)">
      {{ getSelectedSectionRecords().length }} Selected
    </button>
  </mat-menu>

  <mat-form-field appearance="outline" class="mat-form-field-no-padding search-field">
    <mat-icon matPrefix>search</mat-icon>
    <input matInput type="text" (input)="onSearch($event)" placeholder="Search Print Attributes" #searchInput
      data-testid="Search Bar" [formControl]="searchControl" />
    <button type="button" matSuffix mat-icon-button aria-label="Clear" *ngIf="searchInput.value"
      (click)="clearSearch()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
  <button #filterToggleButton type="button" mat-stroked-button class="filter-trigger-btn" matTooltip="Show/hide filters" (click)="toggleFilters()">
    <mat-icon>filter_alt</mat-icon>
  </button>
</div>

<ng-container *ngIf="viewModel$ | async as viewModel">
  <mat-sidenav-container>
    <mat-sidenav #filterSidenav mode="over" position="end" class="filter-drawer">
      <mat-toolbar>
        Filter
        <span class="menu-spacer"></span>
        <button type="button" mat-icon-button aria-label="Close filter menu" matTooltip="Close filter menu"
          (click)="filterSidenav.toggle()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-toolbar>
      <div style="margin: 16px">
        <div fxLayout="column">
          <mat-form-field appearance="outline" class="filter-select-field">
            <mat-label>Division</mat-label>
            <mat-select
              multiple
              [formControl]="divisionFilterControl"
              (selectionChange)="onFilterChange()"
            >
              <mat-option *ngFor="let division of divisionOptions" [value]="division.id">
                {{ division.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="filter-select-field">
            <mat-label>Attribute Type</mat-label>
            <mat-select
              multiple
              [formControl]="attributeTypeFilterControl"
              (selectionChange)="onFilterChange()"
            >
              <mat-option
                *ngFor="let attributeType of attributeTypeOptions"
                [value]="attributeType.id"
              >
                {{ attributeType.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="filter-select-field">
            <mat-label>Event Type</mat-label>
            <mat-select
              multiple
              [formControl]="eventTypeFilterControl"
              (selectionChange)="onFilterChange()"
            >
              <mat-option *ngFor="let eventType of eventTypeOptions" [value]="eventType.id">
                {{ eventType.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="end start" fxLayoutGap="16px">
          <button type="button" mat-stroked-button matTooltip="Reset filters" (click)="resetFilters()">
            Reset
          </button>
          <button type="button" mat-raised-button matTooltip="Apply filters" color="accent"
            (click)="applyFilters()">
            Apply
          </button>
        </div>
      </div>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="filter-chips" *ngIf="activeFilterChips.length" fxLayout="row">
        <mat-chip-set aria-label="Selected filters">
          <mat-chip *ngFor="let chip of activeFilterChips; trackBy: trackChip" (removed)="removeFilterChip(chip)">
            {{ chip.label }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
          <button type="button" class="filter_close_btn" mat-flat-button matTooltip="Remove all filters"
            (click)="clearAllFilterChips()">
            Clear all
          </button>
        </mat-chip-set>
      </div>

      <table *ngIf="viewModel.attributes.length" mat-table [dataSource]="viewModel.attributes" matSort
        matSortActive="Name" matSortDirection="asc" (matSortChange)="onSort($event)" matSortDisableClear
        [matSortStart]="'asc'">

    <ng-container matColumnDef="select" data-testid="Check Box">
      <th class="no-ellipsis" mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()">
        </mat-checkbox>
      </th>
      <td class="no-ellipsis" mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="Name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Name" [resizeColumn]="true">
        Name
      </th>
      <td mat-cell *matCellDef="let record">{{ record.Detail?.PrintAttributeName }}</td>
    </ng-container>

    <!-- Division Column -->
    <ng-container matColumnDef="DivisionNames">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Division Names" [resizeColumn]="true">
        Division
      </th>
      <td mat-cell *matCellDef="let record">{{ record.DivisionNames || (record.Detail?.AllDivisions ? 'All Divisions' : '') }}</td>
    </ng-container>

    <!-- EventTypeNames Column -->
    <ng-container matColumnDef="EventTypeName">
      <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">
        Event Type
      </th>
      <td mat-cell *matCellDef="let record">{{ record.EventTypeName }}</td>
    </ng-container>

    <!-- PrintAttributType Column -->
    <ng-container matColumnDef="PrintAttributeType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Print Attribute Type" [resizeColumn]="true">
        Print Attribute Type
      </th>
      <td mat-cell *matCellDef="let record">
        <span
          class="attr-type-pill"
          [ngClass]="'print-attr-tone--' + attrType"
          *ngIf="record.Detail?.PrintAttributeType as attrType"
        >{{  getPrintAttributeTypeLabel(attrType) }}</span>
      </td>
    </ng-container>

    <!-- AttributeType Column -->
    <!-- <ng-container matColumnDef="AttributeType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Attribute Type" [resizeColumn]="true">
        Attribute Type
      </th>
      <td mat-cell *matCellDef="let record">{{ record.Detail?.AttributeName }}</td>
    </ng-container> -->

    <!-- Description Column -->
    <ng-container matColumnDef="Description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Description" [resizeColumn]="true">
        Description
      </th>
      <td mat-cell *matCellDef="let record">{{ record.Detail?.Description }}</td>
    </ng-container>

    <!-- Banner Column -->
    <ng-container matColumnDef="BannerName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Banner" [resizeColumn]="true">
        Banner
      </th>
      <td mat-cell *matCellDef="let record">{{ record.BannerName }}</td>
    </ng-container>

    <!-- Versions Column -->
    <ng-container matColumnDef="Versions">
      <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">
        Versions
      </th>
      <td mat-cell *matCellDef="let record">{{ record.Detail?.LogicalVersions?.join(', ') }}</td>
    </ng-container>

    <ng-container *ngIf="canEdit()" matColumnDef="Actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let record">
        <button mat-icon-button color="primary" [routerLink]="[record.DomainId]" queryParamsHandling="preserve"
          matTooltip="Edit Attribute">
          Edit
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <table *ngIf="!viewModel.attributes.length">
        <tr>
          <td class="no-records" [attr.colspan]="displayedColumns.length">
            <h2>No Records Found</h2>
          </td>
        </tr>
      </table>

      <mat-paginator *ngIf="viewModel.attributes.length" [pageSizeOptions]="[5, 10, 20, 50, 100]"
        [pageSize]="viewModel.page.pageSize" [length]="viewModel.totalRecords" (page)="onPage($event)">
      </mat-paginator>
    </mat-sidenav-content>
  </mat-sidenav-container>

</ng-container>
